/**
 * Implements Trades Saga
 * Main idea is to fetch trades each time new block mined for ETH
 */
import { IFetchTickersPayload } from '@kattana-io/common';
import { takeLatest, call, select, put, cancelled } from 'redux-saga/effects';

import {
  actionUpdateModal,
  GET_NEXT_PAGE,
  UPDATE_PARAMS,
} from '../actions/modal_search';
import { KattanaAPI } from '../store/createStore';
import { IStore } from '../reducers';
import { EXCLUDED_KINDS } from '../reducers/modal_search';

function* onGetTickers(): any {
  const controller = new AbortController();
  try {
    const { exchanges, chains, search, sort, id, kind, mobile } = yield select(
      (state: IStore) => state.modal_search
    );
    const payload: IFetchTickersPayload = {
      exchanges,
      kind: EXCLUDED_KINDS.includes(kind) ? undefined : kind,
      id,
      searchRaw: search,
      sort,
      mobile,
      chains,
      testnet: kind === 'testnet',
    };
    const data = yield call(KattanaAPI.tickers, payload, {
      signal: controller.signal,
    });
    yield put(actionUpdateModal({ tickers: data, loading: false, page: 0 }));
  } catch (err) {
    yield put(actionUpdateModal({ loading: false }));
    console.error(err);
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* onGetNextPage(): any {
  try {
    const { exchanges, chains, search, tickers, sort, id, kind, mobile } =
      yield select((state: IStore) => state.modal_search);
    const page = yield select((state: IStore) => state.modal_search.page + 1);
    const lengthCheck = mobile
      ? tickers.length % 25 === 0
      : tickers.length % 100 === 0;
    if (lengthCheck) {
      const payload: IFetchTickersPayload = {
        kind: EXCLUDED_KINDS.includes(kind) ? undefined : kind,
        exchanges,
        id,
        searchRaw: search,
        sort,
        page,
        mobile,
        chains,
        testnet: kind === 'testnet',
      };
      const data = yield call(KattanaAPI.tickers, payload);
      if (data[0]) {
        yield put(
          actionUpdateModal({
            tickers: tickers.concat(data),
            page,
            isNextPageLoading: false,
          })
        );
      } else {
        console.warn('This was the last page');
        yield put(
          actionUpdateModal({
            tickers: tickers,
            page: page - 1,
            isNextPageLoading: false,
          })
        );
      }
    } else {
      console.warn('This was the last page');
      yield put(
        actionUpdateModal({
          tickers: tickers,
          page: page - 1,
          isNextPageLoading: false,
        })
      );
    }
  } catch (err) {
    yield put(actionUpdateModal({ isNextPageLoading: false }));
    console.error(err);
  }
}

export default function* modalSearchSaga() {
  yield takeLatest(GET_NEXT_PAGE, onGetNextPage);
  yield takeLatest(UPDATE_PARAMS, onGetTickers);
}
